export default "__VITE_ASSET__DsaG0Um5__"